import React from 'react';
import { motion } from 'framer-motion';
const teamMembers = [{
  name: 'Elena Rostova',
  role: 'Lead Therapist',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  bio: 'Specializes in deep tissue and sports massage with over 10 years of experience.'
}, {
  name: 'Mei Lin Chen',
  role: 'Holistic Healer',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  bio: 'Expert in hot stone therapy and aromatherapy, focusing on energy balance.'
}, {
  name: 'Sarah Jenkins',
  role: 'Prenatal Specialist',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  bio: 'Dedicated to providing safe, relaxing treatments for expectant mothers.'
}, {
  name: 'Yuki Tanaka',
  role: 'Massage Therapist',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  bio: 'Master of Swedish massage techniques, known for her calming presence.'
}];
export function Team() {
  return <section id="team" className="py-24 bg-[#111111]" data-id="element-208">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <div className="text-center mb-16" data-id="element-210">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl text-[#F5F0EB] mb-4" data-id="element-211">
            Meet Our Therapists
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '80px'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="h-1 bg-[#D4AF37] mx-auto mb-6" data-id="element-212" />
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="text-[#999999] max-w-2xl mx-auto text-lg" data-id="element-213">
            Our team of certified professionals is dedicated to your well-being
            and relaxation.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-214">
          {teamMembers.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-[#1A1A1A] rounded-sm overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#2A2A2A]" data-id="element-215">
              <div className="h-80 overflow-hidden" data-id="element-216">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-217" />
              </div>
              <div className="p-6 text-center" data-id="element-218">
                <h3 className="text-2xl text-[#F5F0EB] mb-1" data-id="element-219">{member.name}</h3>
                <p className="text-sm font-medium text-[#D4AF37] uppercase tracking-wider mb-4" data-id="element-220">
                  {member.role}
                </p>
                <p className="text-[#999999] text-sm leading-relaxed" data-id="element-221">
                  {member.bio}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}